<template>
    <div class="row-fill container-col">
      <h1 class="row-fit">
        احصائيات
      </h1>
      <div class="row-fill default-padding">
        <div v-if="stats === null" class="col-fill">
          <div class="loader"/>
        </div>
        <table v-else class="table">
          <tr>
            <td colspan=2><h2> المتونة </h2></td>
          </tr>
          <tr>
            <td> عدد الكلمات</td>
            <td> {{ arabizeNumerals(stats.word_count) }} </td>
          </tr>
          <tr>
            <td> عدد الجمل</td>
            <td> {{ arabizeNumerals(stats.sentence_count) }} </td>
          </tr>
          <tr>
            <td>  عدد الجمل إضيفت خلال الساعات الـ24 الماضية </td>
            <td> {{ arabizeNumerals(stats.sentences_added_last_24h || "-") }} </td>
          </tr>
          <tr>
            <td>  عدد الجمل التي لم يتم استخراج المواردات منها بعد </td>
            <td> {{ arabizeNumerals(stats.sentences_awaiting_extraction || "-") }} </td>
          </tr>
          <tr>
            <td>  عدد المستندات التي لم يتم تحليلها بعد </td>
            <td> {{ arabizeNumerals(stats.documents_awaiting_parsing || "-") }} </td>
          </tr>
          <tr>
            <td colspan=2><h2> التفاعل </h2></td>
          </tr>
          <tr>
            <td> عدد المتواردات التي تمت تقييمها</td>
            <td> {{ arabizeNumerals(stats.feedback.rate_collocation || "-") }} </td>
          </tr>
          <tr>
            <td> عدد الأمثلة التي تم تقييمها</td>
            <td> {{ arabizeNumerals(stats.feedback.rate_instance || "-") }} </td>
          </tr>
          <tr>
            <td> عدد المستخدمين/ات النشطين/ات</td>
            <td>
                {{ arabizeNumerals(stats.user_activity.unique_users_last_24h || "-") }}
                اليوم /
                {{ arabizeNumerals(stats.user_activity.unique_users_last_month || "-") }}
                الشهر                
            </td>
          </tr>
          <tr>
            <td> عدد المتوردات التي تمت مشاهدتها</td>
            <td>
                {{ arabizeNumerals(stats.user_activity.collocations_served_last_24h || "-") }}
                اليوم /
                {{ arabizeNumerals(stats.user_activity.collocations_served_last_month || "-") }}
                الشهر                
            </td>
          </tr>
          <tr>
            <td colspan=2><h2> المتواردات </h2></td>
          </tr>
          <tr>
            <td> عدد المتواردات</td>
            <td> {{ arabizeNumerals(stats.coll_count) }} </td>
          </tr>
          <tr>
            <td> عدد إجمالي لعينات المتواردات</td>
            <td> {{ arabizeNumerals(stats.coll_instance_count) }} </td>
          </tr>
          <tr>
            <td> تردد أكثر المتواردات ترددا</td>
            <td> {{ arabizeNumerals(stats.max_coll_instance_count) }} </td>
          </tr>
        </table>
      </div>
    </div>
</template>

<script>
import { api, baseUrl } from '../mixins/api.js'

export default {
  name: 'ChangesView',
  mixins: [api],
  data: function () {
    return {
      stats: null
    }
  },
  created: function () {
    var t = this
    this.getStats().then(function (response) {
      t.stats = response.data
    })
  },
  computed: {
    serverUrl: function () {
      return baseUrl
    }
  }
}
</script>

<style scoped>
h2 {
  margin-top: 15px;
}
</style>
